import { Tooltip } from '@chakra-ui/react';
import React from 'react';

interface InsuranceStatusProps {
  status?: number;
  dias?: number;
}
export const InsuranceStatus: React.VFC<InsuranceStatusProps> = ({
  status,
  dias,
}) => {
  const getMsgVencimento = () => {
    const diasCorrigido = dias || 0;
    if (dias === 0) {
      return 'Vence hoje';
    }
    return `Vence em ${dias} ${diasCorrigido > 1 ? 'dias' : 'dia'}`;
  };
  const getStatusIcon = () => {
    switch (status) {
      case 0:
        return (
          <Tooltip hasArrow label={getMsgVencimento()} bg="black">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 1.45166L3 4.72485V12C3 20.2207 11.7334 22.4568 11.8213 22.4788L12 22.522L12.1787 22.4788C12.2666 22.4568 21 20.2207 21 12V4.72485L12 1.45166Z"
                fill="black"
              />
              <circle cx="12" cy="12" r="4.5" stroke="white" />
              <path
                d="M11.9744 12.1603V10.4872C11.9744 10.358 11.9231 10.2341 11.8317 10.1427C11.7403 10.0513 11.6164 10 11.4872 10C11.358 10 11.2341 10.0513 11.1427 10.1427C11.0513 10.2341 11 10.358 11 10.4872V12.436C11 12.5201 11.0218 12.6029 11.0633 12.6761C11.1048 12.7493 11.1645 12.8105 11.2367 12.8538L12.8607 13.8282C12.9156 13.8625 12.9768 13.8855 13.0407 13.8958C13.1045 13.9062 13.1698 13.9037 13.2328 13.8886C13.2957 13.8734 13.355 13.8459 13.4071 13.8076C13.4593 13.7693 13.5033 13.721 13.5366 13.6655C13.5699 13.61 13.5918 13.5484 13.601 13.4843C13.6102 13.4203 13.6066 13.355 13.5903 13.2924C13.574 13.2297 13.5454 13.171 13.5062 13.1195C13.4669 13.068 13.4178 13.0249 13.3617 12.9926L11.9744 12.1603Z"
                fill="white"
              />
            </svg>
          </Tooltip>
        );
      case 1:
        return (
          <Tooltip hasArrow label="Apólice vigente" bg="black">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 1.45166L3 4.72485V12C3 20.2207 11.7334 22.4568 11.8213 22.4788L12 22.522L12.1787 22.4788C12.2666 22.4568 21 20.2207 21 12V4.72485L12 1.45166ZM10.5 16.0605L6.96973 12.5303L8.03027 11.4697L10.5 13.9395L15.9697 8.46973L17.0303 9.53027L10.5 16.0605Z"
                fill="black"
              />
            </svg>
          </Tooltip>
        );
      case 2:
        return (
          <Tooltip hasArrow label="Apólice encerrada" bg="black">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 1.45166L3 4.72485V12C3 20.2207 11.7334 22.4568 11.8213 22.4788L12 22.522L12.1787 22.4788C12.2666 22.4568 21 20.2207 21 12V4.72485L12 1.45166Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5303 9.53032L16.0607 8.99999L15 7.93933L14.4697 8.46966L12 10.9393L9.53032 8.46966L8.99999 7.93933L7.93933 8.99999L8.46966 9.53032L10.9393 12L8.46966 14.4697L7.93933 15L8.99999 16.0607L9.53032 15.5303L12 13.0607L14.4697 15.5303L15 16.0607L16.0607 15L15.5303 14.4697L13.0607 12L15.5303 9.53032Z"
                fill="white"
              />
            </svg>
          </Tooltip>
        );
      default:
        return (
          <Tooltip hasArrow label="Não possui seguro" bg="black">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 4C7.58469 4 4 7.58469 4 12C4 16.4153 7.58469 20 12 20C16.4153 20 20 16.4153 20 12C20 7.58469 16.4153 4 12 4ZM13.4688 12.4204C13.4688 11.6093 12.8112 10.9517 12.0001 10.9517C11.6105 10.9517 11.2369 11.1065 10.9614 11.3819C10.686 11.6574 10.5312 12.0309 10.5312 12.4205V15.5473C10.5312 15.9369 10.686 16.3105 10.9614 16.5859C11.2369 16.8613 11.6105 17.0161 12 17.0161C12.8111 17.0161 13.4688 16.3585 13.4688 15.5474V12.4204ZM12 6.98391C11.1894 6.98391 10.5312 7.64203 10.5312 8.45266C10.5312 9.26328 11.1894 9.92141 12 9.92141C12.8106 9.92141 13.4688 9.26328 13.4688 8.45266C13.4688 7.64203 12.8106 6.98391 12 6.98391Z"
                fill="#2C2A29"
              />
            </svg>
          </Tooltip>
        );
    }
  };

  return getStatusIcon();
};
